export default "/assets/images/ifi-logo.svg";